import { Navigate, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import { homeRouteFor } from "../../utils/homeRoute";

const cookies = new Cookies();

export default function ProtectedRoute({ children, allowedRoles }) {
  const location = useLocation();
  const user = cookies.get("MMCL_user");

  if (!user) {
    return <Navigate to="/" replace />;
  }

  const userRole = user.role;
  const roles = Array.isArray(allowedRoles) ? allowedRoles : [];

  // Landing on a route this role can't use is a navigation mistake, not a
  // security event — send them to their own home instead of rendering nothing
  // (blank screen) or clearing the session (which silently logged them out).
  if (!roles.includes(userRole)) {
    const home = homeRouteFor(userRole);
    if (location.pathname === home) return children;
    return <Navigate to={home} replace />;
  }

  return children;
}
